import React from "react";
import "core-js/stable";
import { createRoot } from "react-dom/client";
import * as Sentry from '@sentry/react';
import org_model from 'models/org_model'  // for some reason, import this here removes a cycling dependency loading issue in webpack
if (org_model) {
    // do nothing, just here so linting auto-fix doesn't remove this load-bearing unused import 👆
}
import {
//   createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";
import App from "./App";
// import Main from "Main";
// import MobileMain from "MobileMain";

const denyHosts = ['localhost:9011','icosm.test:9011','inprep.test:9011', 'cbls.test:9011', 'icann.test:9011', 'cmg.test:9011', 'iscr2.test:9011']
const dsn = __BRAND__ == 'instantcosmetics' ? 'https://8f795a819b7d54ebbb6c3dd27b7d75c4@o188559.ingest.us.sentry.io/4510242139734016' : "https://a2f96a24ba9c4d63bc6ae5d52c6ef323@sentry.io/1286240"
Sentry.init( {
				dsn,
				maxBreadcrumbs: 150,
				release: __RELEASE__,
				// debug:true,
				sendDefaultPii:true,
				// tracesSampleRate: 1.0,
				// ignoreErrors: [],
				// denyUrls: denyHosts.map(h=>`http://${h}`),
				integrations: function (integrations) {
					// eslint-disable-next-line no-undef
					if (typeof module !== 'undefined' && module?.hot) {
						console.log('Skipping Sentry reactRouterV6BrowserTracingIntegration due to HMR');
						return integrations;
					}

					integrations.push(
						Sentry.reactRouterV6BrowserTracingIntegration({
							useEffect: React.useEffect,
							useLocation,
							useNavigationType,
							createRoutesFromChildren,
							matchRoutes,
							})
					)
					return integrations
				},
			
				beforeSend(event,hint) {
					if (denyHosts.includes(window.location.host)) 
						return null;
					const code = hint?.originalException?.code 
					/**
					 * Expanding list of non-errors
					 * 
					 * https://firebase.google.com/docs/reference/js/v8/firebase.auth.Auth
					 */
					if (code && ['auth/invalid-email','auth/user-disabled','auth/user-not-found','auth/wrong-password','auth/invalid-verification-code','auth/missing-email','auth/expired-action-code','auth/captcha-check-failed','auth/cancelled-popup-request','auth/popup-blocked','auth/user-token-expired','auth/account-exists-with-different-credential','auth/multi-factor-auth-required','auth/invalid-custom-token','auth/invalid-credential','auth/popup-closed-by-user','auth/missing-password'].includes(code))
						return null
						
					return event
				}
			} );
			
import firebaseApp from 'xAppLib/providers/firebase.js';
import { getPerformance } from "firebase/performance";
// const perf = 
getPerformance(firebaseApp);
// console.log('perf', perf);
// const trace = perf.trace('WebAppRuns');
// console.log('trace', trace);
// trace.start();
// console.log('WebAppRuns');
const content = document.getElementsByClassName('cms').item(0)
if (content) {
    content.querySelector('#main-menu')?.remove()
    content.querySelector('#site-footer')?.remove()
}
window.___ = {loc:location.pathname=='/' ? location.pathname : location.pathname.replace(/\/$/,''),content:content&&content.innerHTML}

const app = document.getElementById("app");
const root = createRoot(app,{
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.warn('Uncaught error', error, errorInfo.componentStack);
	}),
	// Callback called when React catches an error in an ErrorBoundary.
	onCaughtError: Sentry.reactErrorHandler(),
	// Callback called when React automatically recovers from errors.
	onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
	<App />,
	// app.settings.is_mobile && <MobileMain /> || <App />,
);

// trace.stop();
